export async function showMap() {
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const usedRange = sheet.getUsedRange();
      usedRange.load(["values", "rowIndex", "formulas"]);
      await context.sync();

      const allValues = usedRange.values as any[][];

      if (!allValues || allValues.length === 0) {
        console.error("No data found.");
        return;
      }

      const headerRow = allValues[0];
      if (!headerRow || headerRow.length === 0) {
        console.error("No headers found.");
        return;
      }

      // Column indices
      const latIndex = headerRow.findIndex(h =>
        h.toString().toLowerCase().includes("reolyzer_coord_lat")
      );
      const lngIndex = headerRow.findIndex(h =>
        h.toString().toLowerCase().includes("reolyzer_coord_lng")
      );
      const googleStreetViewLinkIndex = headerRow.findIndex(h =>
        h.toString().toLowerCase().includes("reolyzer_google_maps_link")
      );

      if (latIndex === -1 || lngIndex === -1) {
        console.error("Lat and/or Lng columns not found.");
        return;
      }

      // Get visible rows
      const visibleView = usedRange.getVisibleView();
      visibleView.load(["cellAddresses"]);
      await context.sync();

      const cellAreas = visibleView.cellAddresses as string[][][];

      if (!cellAreas || cellAreas.length <= 1) {
        console.warn("No visible rows (excluding header).");
        return;
      }

      // Build data only from visible rows
      const serializedRows = cellAreas.slice(1).map(rowCells => {
        const firstCellAddress = rowCells[0]; // e.g., "A5"
        const match = firstCellAddress.match(/\d+$/);
        const realRowNum = match ? parseInt(match[0], 10) : NaN;
        const dataRowIndex = realRowNum - (usedRange.rowIndex + 1);

        const latValue = allValues[dataRowIndex]?.[latIndex];
        const lngValue = allValues[dataRowIndex]?.[lngIndex];
        const googleLinkValue= allValues[dataRowIndex]?.[googleStreetViewLinkIndex];

        const lat = typeof latValue === "number" ? latValue : parseFloat(latValue);
        const lng = typeof lngValue === "number" ? lngValue : parseFloat(lngValue);

        return {
          Lat: isNaN(lat) ? null : lat,
          Lng: isNaN(lng) ? null : lng,
          GoogleStreetViewLink: googleLinkValue,
          RangeAddress: `${realRowNum}:${realRowNum}`
        };
      });

      const validRows = serializedRows.filter(r => r.Lat !== null && r.Lng !== null);

      if (validRows.length === 0) {
        console.warn("No rows with valid coordinates were found.");
        return;
      }

      const dialogUrl = `${window.location.origin}/map-dialog.html`;

      Office.context.ui.displayDialogAsync(dialogUrl, { height: 90, width: 90 }, result => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          const dialog = result.value as Office.Dialog;

          dialog.addEventHandler(Office.EventType.DialogMessageReceived, e => {
            const command = JSON.parse(e.message);

            if (command.action === "readyForMapData") {
              dialog.messageChild(JSON.stringify({ action: "updateMapData", data: validRows }));
            }
            if (command.action === "selectRangeAddress") {
              selectRange(command.rangeAddress)
                .then(() => console.log("Row selected successfully."))
                .catch((err) => console.error("Error selecting row:", err));
            }
          });

          dialog.addEventHandler(Office.EventType.DialogEventReceived, e => {
            console.log("Dialog closed or error:", e);
          });

          this.registerMapAutoRefresh();
        } else {
          console.error("Error opening dialog:", result.error);
        }
      });
    });
  } catch (error) {
    console.error("Error running showMap():", error);
  }
}

async function selectRange(address: string) {
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getActiveWorksheet();
    await context.sync();
    const range = sheet.getRange(address);
    await context.sync();
    range.select();
    await context.sync();
  });
}